// extracted by mini-css-extract-plugin
export var actionText = "_rr-4";
export var container = "_rr-0";
export var leftSection = "_rr-1";
export var rightSection = "_rr-2";
export var settingsButton = "_rr-6";
export var settingsIcon = "_rr-7";
export var shortcut = "_rr-5";
export var shortcutGroup = "_rr-3";